import { supabase } from '../supabase';
import type { Tables } from '../database.types';

export type Municipality = Tables<'municipalities'>;

/**
 * Fetch all active municipalities
 */
export async function getMunicipalities(): Promise<Municipality[]> {
  const { data, error } = await supabase
    .from('municipalities')
    .select('*')
    .eq('is_active', true)
    .order('name', { ascending: true });

  if (error) throw error;
  return data || [];
}

/**
 * Get a single municipality by ID
 */
export async function getMunicipalityById(id: string): Promise<Municipality | null> {
  const { data, error } = await supabase
    .from('municipalities')
    .select('*')
    .eq('id', id)
    .single();

  if (error) throw error;
  return data;
}

/**
 * Get a municipality by name
 */
export async function getMunicipalityByName(name: string): Promise<Municipality | null> {
  const { data, error } = await supabase
    .from('municipalities')
    .select('*')
    .eq('name', name)
    .eq('is_active', true)
    .limit(1)
    .maybeSingle();

  if (error) {
    if (error.code === 'PGRST116') return null; // Not found
    throw error;
  }
  return data;
}
